import axios from 'axios';
import { BASE_URL } from './api';

// The mailboxes the current user manages (dev/superuser see every approved
// mailbox; everyone else sees the one they own), plus the mailboxes delegated to
// them and the users eligible to be granted access.
// Returns { is_admin, addresses, candidate_users, granted_to_me }.
// Each address carries its signature/logo image urls alongside its access rows.
export async function getMailboxes(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/email-addresses/sender-access/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((response) => response.data)
    .catch((error) => { throw error });
}

// Grant a user permission to send from a mailbox. Returns the updated mailbox.
export async function grantSender(token, mailboxId, userId) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/email-addresses/${mailboxId}/grant/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { user_id: userId },
    }).then((response) => response.data)
    .catch((error) => { throw error });
}

// Revoke a user's permission to send from a mailbox. Returns the updated mailbox.
export async function revokeSender(token, mailboxId, userId) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/email-addresses/${mailboxId}/revoke/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { user_id: userId },
    }).then((response) => response.data)
    .catch((error) => { throw error });
}

// Set a mailbox's signature markup and images. `changes` maps a field name to a
// File (image upload), a string (signature_html, or '' to clear an image), and
// fields left out are untouched by the server -- so only send what changed.
// Returns the updated mailbox.
export async function updateMailboxBranding(token, mailboxId, changes) {
    const formData = new FormData()
    for (const [field, value] of Object.entries(changes)) {
        // A File uploads; a string is sent as-is. A multipart body can't carry a
        // real null, so '' is how "remove this image" is expressed.
        if (value instanceof File) {
            formData.append(field, value, value.name)
        } else {
            formData.append(field, value ?? '')
        }
    }
    return axios({
        method: 'patch',
        url: `${BASE_URL}/email-addresses/${mailboxId}/branding/`,
        headers: { 'Authorization': `Token ${token}` },
        data: formData,
    }).then((response) => response.data)
    .catch((error) => { throw error });
}
